import React, { useState, useEffect } from 'react';
import './Header.css';

function Header() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <header className={`header ${scrolled ? 'scrolled' : ''}`}>
      <div className="header-logo">Portfolio</div>
      <nav className="header-nav">
        <a href="#work">Work</a>
        <a href="#journey">Journey</a>
        <a href="#consulting">Consulting</a>
        <a href="#community">Community</a>
      </nav>
      <a href="#contact" className="header-cta">Hire me</a>
    </header>
  );
}

export default Header;
